export const DefaultStyle = {

    primaryFont: '\'Merriweather\', serif',
    secondaryFont: '\'Titillium Web\', sans-serif',

    themeName: 'erina',

    bgColor: '#D1BDB8',

    primary: '#CB4433',
    /*primaryLight: '#424f77',*/
    /* primaryDark: '#45578d',*/

    secondary: '#573A5B',

    tertiary: '#221625',

    sectionPaddingTopBottom: '170px',
    secondaryPColor: '#fff',

};

const themes = {
    light: {
        foreground: "#000000",
        background: "#eeeeee"
    },
    dark: {
        foreground: "#ffffff",
        background: "#222222"
    }
};